import * as generic from './generic';
import * as abcMale from './abc_male';
import * as animalsKid from './animals_kid';
import * as animalsMale from './animals_male';

export default {
  flipNormal: [
    generic.flipNormal1,
    generic.flipNormal2,
    generic.flipNormal3,
    generic.flipNormal4,
    generic.flipNormal5,
    generic.flipNormal6,
    generic.flipNormal7
  ],
  flipMatching: [
    generic.flipMatching1,
    generic.flipMatching2,
    generic.flipMatching3,
    generic.flipMatching4
  ],
  levelUp: [
    generic.levelUp1,
    generic.levelUp2,
    generic.levelUp3,
    generic.levelUp4,
    generic.levelUp5,
    generic.levelUp6,
    generic.levelUp7
  ],
  abcMale,
  animalsKid,
  animalsMale
};
